export default "__VITE_ASSET__DoJaIHF1__"